import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Row, Col, Typography } from 'antd';
import { Formik, Field, Form } from 'formik';

import {
  RadioGroup,
  DatePickerInput,
  TextArea,
  ArrayInput,
  MultiSelect
} from '@components/form';
import { RegionField } from '@containers/form';

import PropertyActions, {
  PropertySelectors,
  PROPERTY_STEPS
} from '@redux/PropertyRedux';

import API from '@utils/api';
import history from '@utils/history';
import { getErrors } from '@utils/error';

import { transformPropertyToApiRequest } from '@services/transform';

import validationSchema from './schema';

const { Text } = Typography;

function PropertyServiceInfoForm(props) {
  const {
    propertyId: existingId,
    propertyBasicInfo,
    propertyServiceInfo,
    onSubmit,
    onBack,
    onNext
  } = props;

  const handleSubmit = async (values, actions) => {
    const { setSubmitting, setStatus } = actions;
    setSubmitting(true);
    try {
      const valuesToSend = transformPropertyToApiRequest(
        propertyBasicInfo,
        values
      );

      if (!valuesToSend) {
        throw Error('Unsupported Office');
      }

      if (existingId) {
        const { result } = await API.updateProperty(existingId, valuesToSend);
        onSubmit(result, values);
        onNext();
      } else {
        const { result } = await API.createProperty(valuesToSend);
        const { propertyID } = result;
        onNext();
        history.replace(`/properties/${propertyID}/edit`);
      }
    } catch (err) {
      const error = getErrors(err);
      setStatus(error);
    }
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={propertyServiceInfo}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      isInitialValid={validationSchema.isValidSync(propertyServiceInfo)}
      render={({ isValid, isSubmitting, values, status }) => {
        const showActiveAt = values.status !== 'active';

        return (
          <Form className="create-form ant-form-vertical">
            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={RegionField}
                  name="regionID"
                  label="Region"
                  mode="single"
                  showSearch
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Field
                  component={TextArea}
                  name="keyRelease"
                  type="text"
                  label="Key release"
                />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={10}>
                <Field
                  component={ArrayInput}
                  name="keyReleaseEmail"
                  type="email"
                  label="Email(s) to receive key release"
                  innerLabel="Email address"
                  minLen={1}
                  gutter={16}
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={10}>
                <Field
                  component={ArrayInput}
                  name="scheduleEmail"
                  type="email"
                  label="Email(s) to receive daily the list of cleans and key releases"
                  innerLabel="Email address"
                  minLen={1}
                  gutter={16}
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={DatePickerInput}
                  mb={4}
                  name="firstDayOfService"
                  type="date"
                  label="First Day Of Service"
                />
              </Col>
            </Row>

            {/* <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={MultiSelect}
                  mb={4}
                  name="serviceAvailability"
                  options={[
                    { label: 'Monday', value: 'monday' },
                    { label: 'Tuesday', value: 'tuesday' },
                    { label: 'Wednesday', value: 'wednesday' },
                    { label: 'Thursday', value: 'thursday' },
                    { label: 'Friday', value: 'friday' }
                  ]}
                  mode="multiple"
                  label="Service Availability"
                />
              </Col>
            </Row> */}

            <Row gutter={16}>
              <Col span={8}>
                <Field
                  component={RadioGroup}
                  name="status"
                  label="Active"
                  options={[
                    { value: 'inactive', label: 'inactive' },
                    { value: 'active', label: 'Active' }
                  ]}
                />
              </Col>

              {showActiveAt && (
                <Col span={8}>
                  <Field
                    component={DatePickerInput}
                    mb={4}
                    name="activeAt"
                    type="date"
                    label="Active At"
                  />
                </Col>
              )}
            </Row>

            {status && status.message && (
              <Row type="flex" className="action-btns">
                <Col span={8}>
                  <Text type="danger">{status.message}</Text>
                </Col>
              </Row>
            )}

            <Row type="flex" className="action-btns">
              <Button
                disabled={isSubmitting}
                onClick={onBack}
                style={{ marginRight: 10 }}
              >
                Back
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                disabled={!isValid || isSubmitting}
              >
                Submit
              </Button>
            </Row>
          </Form>
        );
      }}
    />
  );
}

PropertyServiceInfoForm.propTypes = {
  propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  propertyServiceInfo: PropTypes.object,
  propertyBasicInfo: PropTypes.object,
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
  onNext: PropTypes.func
};

const mapStateToProps = state => ({
  propertyServiceInfo: PropertySelectors.selectMoreInfo(state),
  propertyBasicInfo: PropertySelectors.selectBasicInfo(state)
});

const mapDispatchToProps = dispatch => ({
  onBack: () => {
    dispatch(PropertyActions.setPropertyStep(PROPERTY_STEPS.BASIC_INFO));
  },
  onSubmit: (newValues, currentData) => {
    dispatch(PropertyActions.updateLocalProperty(newValues, currentData));
  },
  onNext: () => {
    dispatch(PropertyActions.setPropertyStep(PROPERTY_STEPS.PRICING));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyServiceInfoForm);
